// Eventos en vivo de la oficina v2 para toda la app autenticada (diseño D8), sobre la misma
// conexión compartida (getSocket). Los eventos de agentes siguen escuchándose solo en /home
// (useSocket), como antes: así la oficina no hereda avisos que no puede mostrar.
// 09-10: y el «abre este agente» del service worker al tocar una notificación (abrirDesdeAviso.ts).
import { useSocketOficina } from './useSocketOficina';
import { useAbrirDesdeAviso } from './abrirDesdeAviso';

export function SocketRaiz(): null {
  useSocketOficina();
  useAbrirDesdeAviso();
  return null;
}
